/*
 * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *    .       .       .       .       .       .       .       .       .       .       .       .
 *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *      ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *   . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *        .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *   .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *
 * Copyright FortyFix(c) 2024.
 * Title: taglie.component.ts;
 * Path: /Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/GESFF_Gestionale_FF_Angular/src/app/Prodotti/taglie/taglie.component.ts;
 * Description: ;
 * Author: giovannibattistadellaporta;
 * Created at: 03/04/24, 17:12;
 * Updated at: 03/04/24, 17:12;
 *
 *
 */

import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import { ApiPathsService } from "src/app/api-paths.service";
import {environment} from "../../../environments/environment";
import {Permission} from "../../Login/_guards/Permission";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-taglie',
  templateUrl: './taglie.component.html'
})
export class TaglieComponent implements OnInit {
  @Input() items: any[] ;
  @Output() itemsChange = new EventEmitter<any[]>();
  constructor(
    private ApiPaths: ApiPathsService,
    public permission: Permission,
    private toastService: ToastrService
  ) { }

  ngOnInit(): void {
    this.Refresh();
  }
  Refresh(){
    this.ApiPaths.ClassicPost("/prodotti/taglia/list", {page:0, size: 10}).subscribe(data => {
      this.items = data.data;
    })
  }
  protected readonly environment = environment;

  editing(item?: any){
    return !item?.modifica && this.items.filter(x=> x.modifica).length > 0
  }
  edit(item: any) {
    if(!item.modifica && this.items.filter(x=> x.modifica).length > 0) {
      this.toastService.warning("Salvare l'elemento in sospeso prima di modificare/aggiungere un'altro elemento");
    }
    else if(item.modifica && (item.taglia.length <= 0 || item.fattore <= 0) ) {
      this.toastService.warning("Inserire il valore di taglia e fattore per salvare l'elemento");
    }
    else if(item.modifica ) {
      this.ApiPaths.ClassicPost(item.id?"/prodotti/taglia/update" : "/prodotti/taglia/add", item).subscribe(() => {
        item.modifica = !item.modifica;
        this.Refresh();
      });
    }
    else {
      item.modifica = !item.modifica;
    }
  }
  add(){
    if(this.items.filter(x=> x.modifica).length > 0) {
      this.toastService.warning("Salvare l'elemento in sospeso prima di modificare/aggiungere un'altro elemento");
    }else
    this.items.push({modifica: true, taglia: "", id: undefined, fattore: 1});
  }

  delete(item: any) {
    if(!confirm('Sei sicuro di voler eliminare questo elemento?')) return;
    if(item.id){
      this.ApiPaths.ClassicPost("/prodotti/taglia/delete ", {id: item.id}).subscribe(() => {
        this.items = this.items.filter(x=> x.id != item.id);
        this.Refresh();
      });
    }else{
      const index = this.items.findIndex(x=> x == item);
      if(index === -1) return;
      this.items.splice(index, 1);
    }

  }
}
